import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Card from 'Core/components/FormElements/Card';
import TermsInput from 'Core/components/FormElements/TermsInput';
import { PrimaryButton } from 'Core/components/Button';
import { AlertError } from 'Core/components/Alert';
import Loader from 'Core/components/Loader';
import TermsModal from 'Modules/easyCredit/components/TermsModal';
import { messageOf } from 'Modules/checkout/api';

export default function Consent({ mutation }) {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  if (mutation.isLoading) {
    return <Loader message={t('status.loading.processingRequest', 'Anfrage wird verarbeitet …')} />;
  }

  const submit = () =>
    mutation.mutate({
      data_processing: true,
      accepted_terms_and_condition: t('easyCredit.consentContent.checkboxLabel'),
    });

  return (
    <Card className="border-solid border-gray-300 shadow-md" data-testid="consent">
      <h3 className="text-lg font-bold text-gray-900 mb-2">
        {t('easyCredit.consentContent.title', 'Einwilligung für Ihren Ratenkauf')}
      </h3>
      {mutation.isError && <AlertError>{messageOf(mutation.error)}</AlertError>}
      <p className="text-sm text-gray-700 leading-relaxed mb-3">
        <Trans
          i18nKey="easyCredit.consentContent.para1"
          components={{
            termsLink: (
              <button
                type="button"
                onClick={() => setTermsOpen(true)}
                className="text-blue-600 hover:text-blue-800 underline font-medium cursor-pointer bg-transparent border-none p-0 inline"
              />
            ),
          }}
        />
      </p>
      <div className="bg-amber-50 rounded-lg p-3 border border-amber-200 mb-4">
        <TermsInput name="terms" onChange={(e) => setAccepted(e.target.checked)}>
          <span className="text-sm font-semibold text-gray-800">
            {t('easyCredit.consentContent.checkboxLabel')}
          </span>
        </TermsInput>
      </div>
      <div className="flex justify-end">
        <PrimaryButton
          type="button"
          data-testid="consent-submit"
          disabled={!accepted}
          onClick={submit}
        >
          {t('easyCredit.consentContent.requestFinancingBtnLabel', 'Finanzierung anfragen')}
        </PrimaryButton>
      </div>
      <TermsModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} />
    </Card>
  );
}
